import React from 'react';
import * as ourUser from './ourUser.module.scss';


export default function OurUser({context}) {

  return (
    <div className={ourUser.userArea}>
      <ul className={ourUser.userArea__list}>
        {context.map((data, i) => (
          <li className={ourUser.userArea__item} key={i}>
            <img src={data.imageUrl} alt={data.imageText} />
          </li>
        ))}
      </ul>
      
    </div>
  )
}
